<li class="panel">
	<div class="pratica" [ngClass]="tipoPraticaClassCss">
		<div>
			<p class="categoria" [ngClass]="tipoPraticaClassCss">{{pratica.intestazione.campi.tipoPratica | tipoPraticaPipe}}</p>
			<p class="codice" style="margin-bottom:15px">{{pratica.intestazione.campi.posizionePratica}}</p>
			<p class="codice" *ngIf="pratica?.numeroProtocollo">{{pratica.numeroProtocollo}}</p>
			<!-- <p class="codice" *ngIf="pratica?.numeroFascicoloProtocollo">Fasc.{{pratica?.numeroFascicoloProtocollo}}</p> -->
    	</div>
		<div class="data_opzioni fasi" *ngIf="isPraticaVisible">
			<ul>
				<li class="opzioni" appDropdownFocus><a class="dropdown-toggle"
					[attr.data-toggle]="'dropdown'" href="#" [attr.role]="'button'"
					aria-haspopup="true" aria-expanded="false">Opzioni<span
						class="glyphicon glyphicon-option-vertical"></span></a>
					<div class="dropdown-menu">
								<ul *ngIf="descrittori" option-pratica [pratica]="pratica" [descrittori]="descrittori"
									(onReturnMethodPraticaOption)="runMethodPraticaOption($event.method, $event.pratica)">
								</ul>
					</div></li>
			</ul>
		</div>
		<div>
			<p class="identificativo">
				DEL {{
				pratica.intestazione.campi.dataApertura | date:'dd/MM/yyyy' }} {{
				pratica.intestazione.campi.definita ? 'DEFINITA IL ' +
				(pratica.intestazione.campi.dataDefinizione | date:'dd/MM/yyyy') :
				'' }} &nbsp;
				<ng-container *ngIf="pratica.intestazione.campi.numeroSinistro && hasFascicoloSanitario()">{{ ' - N° sinistro ' + pratica.intestazione.campi.numeroSinistro }}</ng-container>
				<span *ngIf="pratica.intestazione.campi.definita"
					title="Definita" class="glyphicon glyphicon-lock"></span>
				<span *ngIf="pratica.correlata" title="Correlata"
					class="glyphicon glyphicon-link"></span>
				<span *ngIf="pratica.capofila"
					title="Capofila riunione di giudizi"
					class="riunionegiudizi glyphicon glyphicon-resize-small"><span
					class="glyphicon capofila">C</span></span>
				<span *ngIf="pratica.riunita"
					title="Riunione di giudizi"
					class="glyphicon glyphicon-resize-small"></span>
				<span *ngIf="pratica.archiviata"
					title="Archiviata" class="glyphicon glyphicon-floppy-saved"></span>
        <span *ngIf="!isPraticaVisible" title="Vietato" class="glyphicon glyphicon-ban-circle"></span>
			
			<div class="titolo">
				<a
					[routerLink]="['/pratica', tipoPratica, getPraticaViewPath(), pratica.id]">
					{{pratica.intestazione.campi.contropartePrimaria ?
					pratica.intestazione.campi.contropartePrimaria + " - " :
					"Nessun soggetto/parte specificato" }} {{
					pratica.intestazione.campi.materia ?
					pratica.intestazione.campi.materia + "/" : ""}} {{
					pratica.intestazione.campi.oggetto ?
					pratica.intestazione.campi.oggetto : "" }} </a>
			</div>
		</div>
	</div>
</li>

<div class="modal fade" id="modaladdFascicolo" tabindex="-1" role="dialog" style="display: none;"
	fascicolo-select-modal #fascicoloSelectModal (onReturn)="manageModal()"></div>

<div archivia-pratica-mod-update id="modaleDataArchiviazione" #modaleDataArchiviazione></div>

<div class="modal fade" id="modalCorrelaPratica" tabindex="-1" role="dialog" style="display: none;"
	correla-pratica #correlaPraticaModal (onReturn)="returnCorrela($event)"></div>

<div class="modal fade" id="modalCopiaPratica" tabindex="-1" role="dialog" style="display: none;"
	copia-pratica #copiaPraticaModal (onReturn)="manageModal()"></div>

<div class="modal fade" id="modalRicercaPrecedenti" tabindex="-1" role="dialog" style="display: none;"
	ricerca-precedenti #ricercaPrecedentiModal (onReturn)="returnPrecedenti($event)"></div>
